export default __webpack_public_path__ + "static/media/woman.7dd7c3d9.jpg";